module.exports = __webpack_public_path__ + "static/media/apple.9bef9b20.svg";